import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { localReportAction, reportListLimit, reportPage } from "./reportRequest";
import { isFullExportReport } from "./reportPaginationPolicy";

import { FINANCIAL_MONEY_BASIS, FINANCIAL_REPORTS } from "./financialMeasures";

const API_URL = config.API_URL;

const view = (values) => {
  const result = values && values.result ? values.result : "";
  const ScreenReport = values && values.ScreenReport ? values.ScreenReport : "";
  const daterange = values && values.daterange ? values.daterange : "";
  const start_date = values && values.start_date ? values.start_date : "";
  const end_date = values && values.end_date ? values.end_date : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const supplier_id = values && values.supplier_id ? values.supplier_id : "";
  const service_id = values && values.service_id ? values.service_id : "";
  const product_id = values && values.product_id ? values.product_id : "";
  const month = values && values.month ? values.month : "";
  const status = values && values.status ? values.status : "";
  const search = values && values.search ? values.search : "";
  const search_all_dates = values && values.search_all_dates === true;
  const sort = values && values.sort && values.sort ? values.sort : "";
  const filter_customer_name = values && values.filter_customer_name ? values.filter_customer_name : "";
  const filter_customer_email = values && values.filter_customer_email ? values.filter_customer_email : "";
  const filter_customer_mobile = values && values.filter_customer_mobile ? values.filter_customer_mobile : "";
  const filter_last_booking = values && values.filter_last_booking ? values.filter_last_booking : "";
  const filter_last_service = values && values.filter_last_service ? values.filter_last_service : "";
  const filter_days_absent = values && values.filter_days_absent ? values.filter_days_absent : "";
  const filter_staff_name = values && values.filter_staff_name ? values.filter_staff_name : "";
  const filter_total_sales = values && values.filter_total_sales ? values.filter_total_sales : "";
  const absence_period = values && values.absence_period != null && values.absence_period !== "" ? values.absence_period : "";
  const filter_service_category = values && values.filter_service_category ? values.filter_service_category : "";
  const filter_product_name = values && values.filter_product_name ? values.filter_product_name : "";
  const filter_sku = values && values.filter_sku ? values.filter_sku : "";
  const filter_supplier_name = values && values.filter_supplier_name ? values.filter_supplier_name : "";
  const filter_available_stock = values && values.filter_available_stock ? values.filter_available_stock : "";
  const filter_stock_sold = values && values.filter_stock_sold ? values.filter_stock_sold : "";
  const filter_cost_price = values && values.filter_cost_price ? values.filter_cost_price : "";
  const filter_retail_price = values && values.filter_retail_price ? values.filter_retail_price : "";
  const stock_as_of_date = values && values.stock_as_of_date ? values.stock_as_of_date : "";
  const low_stock_below =
    values && values.low_stock_below !== null && values.low_stock_below !== "" ? values.low_stock_below : "";
  const finishes_within_months =
    values && values.finishes_within_months ? values.finishes_within_months : "";

  let sortstring = "";
  if (sort) {
    let sortArray = [];
    let sortSubArray = [];
    Object.keys(sort).map(function (key, index) {
      if (Object.keys(sort[key]).length > 0) {
        Object.keys(sort[key]).map(function (subkey, subindex) {
          sortSubArray[subindex] = `sort[${key}.${subkey}]=${sort[key][subkey]}`;
        });
      }
      if (key != "category") {
        sortArray[index] = `sort[${key}]=${sort[key]}`;
      }
    });
    if (sortSubArray.length > 0) {
      let jsubsort = sortSubArray.join("&");
      sortstring = jsubsort;
    }
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }

  let pagination = values && values.pagination ? values.pagination : "";

  if (pagination) {
    pagination = values && values.option ? false : true;
  } else {
    pagination = false;
  }

  if (isFullExportReport(ScreenReport)) {
    pagination = true;
  }
  const action = localReportAction("afterlogin/report/view", values, sortstring);
  const data = {
    pagination: values && values.id ? false : pagination, //true or false
    result: result, //business_name,owner_name
    ScreenReport: ScreenReport,
    ...(FINANCIAL_REPORTS.includes(ScreenReport) ? { money_basis: FINANCIAL_MONEY_BASIS } : {}),
    daterange: daterange,
    start_date: start_date,
    end_date: end_date,
    staff_id: staff_id,
    supplier_id: supplier_id,
    service_id: service_id,
    product_id: product_id,
    sort: sort,
    month: month,
    status: status,
    search: search,
    search_all_dates: search_all_dates,
    filter_customer_name: filter_customer_name,
    filter_customer_email: filter_customer_email,
    filter_customer_mobile: filter_customer_mobile,
    filter_last_booking: filter_last_booking,
    filter_last_service: filter_last_service,
    filter_days_absent: filter_days_absent,
    filter_staff_name: filter_staff_name,
    filter_total_sales: filter_total_sales,
    filter_product_name: filter_product_name,
    filter_sku: filter_sku,
    filter_supplier_name: filter_supplier_name,
    filter_available_stock: filter_available_stock,
    filter_stock_sold: filter_stock_sold,
    filter_cost_price: filter_cost_price,
    filter_retail_price: filter_retail_price,
    stock_as_of_date: stock_as_of_date,
    low_stock_below: low_stock_below,
    absence_period: absence_period,
    filter_service_category: filter_service_category,
    finishes_within_months: finishes_within_months,
    ...(ScreenReport === "sales_by_end_of_day" && values?.layout === "laravel"
      ? { layout: "laravel" }
      : {}),
  };
  const limit = reportListLimit(values);
  if (limit) data.limit = limit;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const printout = () => {

};

const moreclientbyproducts = (values) => {
  const action = "afterlogin/report/clientcartproducts";
  const payload = {
    client_id: values && values.client_id,
  };
  const listLimit = reportListLimit(values);
  ["daterange", "start_date", "end_date", "limit"].forEach((key) => {
    if (values && values[key] !== undefined && values[key] !== null && values[key] !== "") {
      payload[key] = values[key];
    }
  });
  if (listLimit) payload.limit = listLimit;
  const page = reportPage(values);
  const pageQuery = page ? `?page=${page}` : "";
  return axios.post(API_URL + action + pageQuery, payload, { headers: authHeader() });
};

const reportApiController = {
  view,
  printout,
  moreclientbyproducts
};
export default reportApiController;
